export enum AlertListSubTabs {
	CHANNELS = 'channels',
	ROUTING_POLICIES = 'routing-policies',
	PLANNED_DOWNTIME = 'planned-downtime',
}

export enum AlertListTabs {
	TRIGGERED_ALERTS = 'TriggeredAlerts',
	ALERT_RULES = 'AlertRules',
	CONFIGURATION = 'Configuration',
	CHANNELS = 'Channels',
	ROUTING_POLICIES = 'RoutingPolicies',
	PLANNED_DOWNTIME = 'PlannedDowntime',
}
